import { getEnvironmentKey } from './environment'
// The server redirects read this file too, so it is JSON.
import rootstechEventIds from './rootstech-event-ids.json'

type ConferenceDates = {
  start: string
  end: string
}

type RootstechConfig = {
  conference: Record<number, ConferenceDates>
}

const rootstechConfig: RootstechConfig = {
  conference: {
    2026: {
      start: '2026-03-05T16:00:00-07:00',
      end: '2026-03-07T18:00:00-07:00',
    },
  },
}

export default rootstechConfig

/** Returns the RootsTech event id for this environment. Update the prod id in the JSON file each year. */
export function getRootstechEventId(): string {
  return rootstechEventIds[getEnvironmentKey()]
}
